<template>
  <div class="box14">
    <pageTitle
      title="就业岗位多"
      text="博学谷AI毕业学生项目经验丰富，就业选择范围众多、<br/>就业发展前景广阔"
    />

    <div class="demo-box">
      <vue-seamless-scroll
        :data="list1"
        :class-option="classOption"
        class="seamless-warp"
      >
        <div class="demo">
          <div v-for="i in list1" :key="i">{{ i }}</div>
        </div>
      </vue-seamless-scroll>

      <vue-seamless-scroll
        :data="list1"
        :class-option="classOption"
        class="seamless-warp"
      >
        <!-- <div class="demo-box"> -->
        <!-- <div class="demo">
          <div v-for="i in list1" :key="i">{{ i }}</div>
        </div> -->
        <div class="demo">
          <div v-for="j in list2" :key="j">{{ j }}</div>
        </div>
        <!-- </div> -->
      </vue-seamless-scroll>
    </div>

    <div class="title">
      <img src="../../../assets/coursePage/ai/box13/icon.png" alt />
      <p>三大主流就业方向</p>
      <img src="../../../assets/coursePage/ai/box13/icon.png" alt />
    </div>

    <div class="top-box">
      <div class="tag">博学谷毕业学员起点</div>
      <div class="block">
        <p>
          高级AI开发工程师
          <span>（2-4年开发经验）</span>
        </p>
      </div>
    </div>

    <div class="direction-box">
      <div class="direction">
        <div class="tit">技术方向</div>

        <div class="txt-block">
          资深开发工程师
          <br />(4-6年)
        </div>
        <div class="txt-block">
          技术专家
          <br />(6-10年)
        </div>
        <div class="txt-block">
          CTO
          <br />(6-10年)
        </div>
      </div>

      <div class="direction">
        <div class="tit">管理方向</div>

        <div class="txt-block">
          技术开发组长
          <br />(4-6年)
        </div>
        <div class="txt-block">
          项目经理
          <br />(6-10年)
        </div>
        <div class="txt-block">
          项目总监
          <br />(6-10年)
        </div>
      </div>

      <div class="direction">
        <div class="tit">
          新技术
          <br />创业方向
        </div>

        <div class="txt-block">
          行业大牛
          <br />(4-6年)
        </div>
        <div class="txt-block height-box">
          AI新型技术
          <br />创业者 <br />(10年以上)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list1: [
        "深度学习算法工程师",
        "数据分析工程师",
        "数据挖掘工程师",
        "推荐系统工程师",
      ],
      list2: [
        "机器学习算法工程师",
        "知识图谱工程师",
        "图像与视觉处理开发工程师",
        "自然语言处理开发工程师",
      ],
    };
  },
  computed: {
    classOption() {
      return {
        direction: 2,
        step: 0.5,
        limitMoveNum: 2,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.box14 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box14/bg.png") no-repeat;
  background-size: cover;
  text-align: center;
  overflow: hidden;

  .demo-box {
    margin-top: 48px;
    margin-bottom: 44px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1d2129;
  }

  .demo {
    display: flex;
    margin-bottom: 32px;
    // padding-left: 32px;
    div {
      margin-right: 24px;
      padding: 0px 32px;
      height: 72px;
      background: linear-gradient(180deg, #e1f7ff 0%, #ffffff 100%);
      box-shadow: 0px 4px 12px 0px rgba(64, 189, 255, 0.12);
      border-radius: 36px;
      text-align: center;
      line-height: 72px;
      border: 1px solid #ffffff;
      box-sizing: border-box;
      white-space: nowrap;
    }
  }

  .demo1 {
    // margin-left: 108px;
  }

  .title {
    margin-top: 44px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    img {
      width: 40px;
      height: 40px;
    }
    p {
      margin: 0px 16px;
      font-size: 28px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: #4e5969;
      line-height: 44px;
      background: linear-gradient(270deg, #65adff 0%, #1fd7cd 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .top-box {
    position: relative;
    margin: 0 auto;
    width: 686px;
    height: 152px;
    background: rgba(236, 250, 255, 0.6);
    border-radius: 16px;
    border: 2px dashed #24d4d0;
    .block {
      margin: 0 auto;
      margin-top: 44px;
      width: 662px;
      height: 96px;
      background: #ffffff;
      box-shadow: 0px 4px 12px 0px rgba(64, 255, 239, 0.12);
      border-radius: 16px;
      text-align: center;
      line-height: 96px;
      border: 1px solid #ffffff;
      p {
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #1d2129;
        span {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #1d2129;
        }
      }
    }
    .tag {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 272px;
      height: 60px;
      background: url("../../../assets/coursePage/ai/box14/bg-text.png")
        no-repeat;
      background-size: cover;
      text-align: center;
      line-height: 60px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #00c7c3;
    }
  }

  .direction-box {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    .direction {
      position: relative;
      width: 212px;
      // height: 560px;
      background: rgba(231, 237, 255, 0.6);
      border-radius: 12px;
      border: 2px dashed rgba(22, 93, 255, 0.5);

      .tit {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 108px;

        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #165dff;
      }

      .txt-block {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 0 auto;
        margin-bottom: 48px;
        width: 188px;
        height: 112px;
        background: #ffffff;
        box-shadow: 0px 4px 12px 0px rgba(64, 128, 255, 0.12);
        border-radius: 8px;

        line-height: 40px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1d2129;
        border: 1px solid #ffffff;

        &::after {
          position: absolute;
          bottom: -40px;
          left: 50%;
          transform: translate(-50%, 0px);
          content: "";
          width: 32px;
          height: 32px;
          background: url("../../../assets/coursePage/ai/box14/arrow-b.png")
            no-repeat;
          background-size: cover;
        }

        &:last-child {
          margin-bottom: 20px;
          &::after {
            content: "";
            display: none;
          }
        }
      }

      .height-box {
        height: 272px;
      }

      &::after {
        position: absolute;
        top: -40px;
        left: 50%;
        transform: translate(-50%, 0px);
        content: "";
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box14/arow-g.png")
          no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>
